import type { ProjectRemote } from '../types.tsx';
import { applyProjectTemplate } from './apply-template/index.tsx';
import { checkProjectOnboarded } from './check-onboarded/index.tsx';

export const projectRemote: ProjectRemote = {
	checkProjectOnboarded,
	applyProjectTemplate,
};
